import React, { useState, useEffect } from "react";
import {
  getToken,
  getUserData,
  isAuthenticated,
} from "../services/tokenService";
import { useAuth } from "../contexts/AuthContext";

export function AuthDebug() {
  const { user, isAuthenticated: contextAuthenticated } = useAuth();
  const [debugInfo, setDebugInfo] = useState<any>({});
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(true);

  useEffect(() => {
    const updateDebugInfo = () => {
      const token = getToken();
      const userData = getUserData();
      const cookieAuth = isAuthenticated();

      setDebugInfo({
        token: token ? `${token.substring(0, 20)}...` : "Não encontrado",
        userData: userData
          ? {
              email: userData.email,
              name: userData.name,
            }
          : "Não encontrado",
        cookieAuth,
        contextUser: user
          ? {
              email: user.email,
              name: user.name,
            }
          : "Não encontrado",
        contextAuthenticated,
        allCookies: document.cookie,
      });
    };

    updateDebugInfo();
    const interval = setInterval(updateDebugInfo, 1000);

    return () => clearInterval(interval);
  }, [user, contextAuthenticated]);

  // Só renderiza em desenvolvimento
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: "10px",
        right: "10px",
        zIndex: 9999,
      }}
    >
      {/* Botão de Toggle */}
      <button
        onClick={() => setIsVisible(!isVisible)}
        style={{
          background: "rgba(0,0,0,0.8)",
          color: "white",
          border: "none",
          padding: "8px 12px",
          borderRadius: "5px",
          fontSize: "12px",
          cursor: "pointer",
          marginBottom: "5px",
          display: "flex",
          alignItems: "center",
          gap: "5px",
        }}
        title={isVisible ? "Ocultar Debug" : "Mostrar Debug"}
      >
        🔍 {isVisible ? "Ocultar" : "Debug"}
      </button>

      {/* Painel de Debug */}
      {isVisible && (
        <div
          style={{
            background: "rgba(0,0,0,0.9)",
            color: "white",
            padding: "15px",
            borderRadius: "8px",
            fontSize: "12px",
            maxWidth: "350px",
            maxHeight: "400px",
            overflow: "auto",
            border: "1px solid #333",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          }}
        >
          {/* Cabeçalho */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
              borderBottom: "1px solid #333",
              paddingBottom: "8px",
            }}
          >
            <h4 style={{ margin: 0, color: "#60a5fa" }}>
              🔍 Debug de Autenticação
            </h4>
            <div style={{ display: "flex", gap: "5px" }}>
              <button
                onClick={() => setIsMinimized(!isMinimized)}
                style={{
                  background: "transparent",
                  border: "1px solid #555",
                  color: "white",
                  padding: "2px 6px",
                  borderRadius: "3px",
                  fontSize: "10px",
                  cursor: "pointer",
                }}
                title={isMinimized ? "Expandir" : "Minimizar"}
              >
                {isMinimized ? "⬇️" : "⬆️"}
              </button>
              <button
                onClick={() => setIsVisible(false)}
                style={{
                  background: "transparent",
                  border: "1px solid #555",
                  color: "white",
                  padding: "2px 6px",
                  borderRadius: "3px",
                  fontSize: "10px",
                  cursor: "pointer",
                }}
                title="Fechar"
              >
                ✕
              </button>
            </div>
          </div>

          {/* Conteúdo */}
          {!isMinimized && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              {/* Token */}
              <div>
                <strong style={{ color: "#fbbf24" }}>Token:</strong>
                <div
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    padding: "4px 6px",
                    borderRadius: "3px",
                    marginTop: "2px",
                    fontFamily: "monospace",
                    fontSize: "11px",
                    wordBreak: "break-all",
                  }}
                >
                  {debugInfo.token}
                </div>
              </div>

              {/* User Data (Cookie) */}
              <div>
                <strong style={{ color: "#34d399" }}>
                  User Data (Cookie):
                </strong>
                <div
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    padding: "4px 6px",
                    borderRadius: "3px",
                    marginTop: "2px",
                    fontFamily: "monospace",
                    fontSize: "11px",
                    maxHeight: "60px",
                    overflow: "auto",
                  }}
                >
                  {JSON.stringify(debugInfo.userData, null, 2)}
                </div>
              </div>

              {/* Status de Autenticação */}
              <div style={{ display: "flex", gap: "15px" }}>
                <div>
                  <strong style={{ color: "#60a5fa" }}>Cookie Auth:</strong>
                  <span style={{ marginLeft: "5px" }}>
                    {debugInfo.cookieAuth ? "✅" : "❌"}
                  </span>
                </div>
                <div>
                  <strong style={{ color: "#a78bfa" }}>Context Auth:</strong>
                  <span style={{ marginLeft: "5px" }}>
                    {debugInfo.contextAuthenticated ? "✅" : "❌"}
                  </span>
                </div>
              </div>

              {/* Context User */}
              <div>
                <strong style={{ color: "#f472b6" }}>Context User:</strong>
                <div
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    padding: "4px 6px",
                    borderRadius: "3px",
                    marginTop: "2px",
                    fontFamily: "monospace",
                    fontSize: "11px",
                    maxHeight: "60px",
                    overflow: "auto",
                  }}
                >
                  {JSON.stringify(debugInfo.contextUser, null, 2)}
                </div>
              </div>

              {/* Cookies (colapsível) */}
              <details>
                <summary style={{ cursor: "pointer", color: "#fbbf24" }}>
                  <strong>Cookies ({document.cookie.split(";").length})</strong>
                </summary>
                <div
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    padding: "4px 6px",
                    borderRadius: "3px",
                    marginTop: "4px",
                    fontFamily: "monospace",
                    fontSize: "10px",
                    maxHeight: "80px",
                    overflow: "auto",
                    wordBreak: "break-all",
                  }}
                >
                  {debugInfo.allCookies || "Nenhum cookie encontrado"}
                </div>
              </details>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
